<mat-form-field>
  <mat-label>{{ label }}</mat-label>

  <mat-select [formControl]="control" [required]="isRequired(control)">
    <mat-option [value]="null">-</mat-option>

    @for (option of options; track $index) {
      <mat-option [value]="option">{{ option.description }}</mat-option>
    }
  </mat-select>
</mat-form-field>
